// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mT","left":"mU","center":"mV","right":"mW"};